import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { COMPANY } from "../lib/constants";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#223429] text-[#F9F6F0] pt-24 pb-10 mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
                <div className="md:col-span-5">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="relative w-12 h-12 overflow-hidden rounded-sm bg-[#F9F6F0]">
                            <img
                                src={COMPANY.logo}
                                alt="Fyr og Finér logo"
                                className="w-full h-full object-cover"
                            />
                        </span>
                        <div className="leading-none">
                            <div className="font-serif text-2xl">
                                Fyr <span className="italic">&amp;</span> Finér
                            </div>
                            <div className="overline mt-1 text-[#F9F6F0]/60">
                                Tømrerfirmaet · ApS
                            </div>
                        </div>
                    </div>
                    <p className="text-[#F9F6F0]/75 max-w-md font-light leading-relaxed">
                        Kvalitetshåndværk uden kompromis. Vi tager både de
                        små og de større opgaver — tag, solceller, døre,
                        vinduer, terrasser og alt derimellem.
                    </p>
                    <div className="mt-6 font-serif italic text-[#F9F6F0]/90 text-lg">
                        Alt andet er bare spån.
                    </div>
                </div>

                <div className="md:col-span-3">
                    <div className="overline mb-5 text-[#F9F6F0]/60">
                        Gå til
                    </div>
                    <ul className="flex flex-col gap-3 text-[#F9F6F0]/90">
                        <li>
                            <Link
                                to="/"
                                data-testid="footer-link-forside"
                                className="link-reveal"
                            >
                                Forside
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/projekter"
                                data-testid="footer-link-projekter"
                                className="link-reveal"
                            >
                                Projekter
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/om-os"
                                data-testid="footer-link-om-os"
                                className="link-reveal"
                            >
                                Om os
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/kontakt"
                                data-testid="footer-link-kontakt"
                                className="link-reveal"
                            >
                                Kontakt
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <div className="overline mb-5 text-[#F9F6F0]/60">
                        Kontakt
                    </div>
                    <ul className="flex flex-col gap-4 text-[#F9F6F0]/90">
                        <li>
                            <a
                                href={COMPANY.phoneHref}
                                data-testid="footer-phone-link"
                                className="inline-flex items-center gap-3 link-reveal"
                            >
                                <Phone size={16} /> {COMPANY.phone}
                            </a>
                        </li>
                        <li>
                            <a
                                href={COMPANY.emailHref}
                                data-testid="footer-email-link"
                                className="inline-flex items-center gap-3 link-reveal break-all"
                            >
                                <Mail size={16} /> {COMPANY.email}
                            </a>
                        </li>
                        <li className="inline-flex items-start gap-3 text-[#F9F6F0]/80">
                            <MapPin size={16} className="mt-1" />
                            <span>{COMPANY.address}</span>
                        </li>
                    </ul>

                    <div className="flex items-center gap-4 mt-8">
                        <a
                            href={COMPANY.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-facebook-link"
                            className="w-10 h-10 rounded-sm border border-[#F9F6F0]/30 hover:border-[#F9F6F0] inline-flex items-center justify-center transition-colors"
                            aria-label="Facebook"
                        >
                            <Facebook size={16} />
                        </a>
                        <a
                            href={COMPANY.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-instagram-link"
                            className="w-10 h-10 rounded-sm border border-[#F9F6F0]/30 hover:border-[#F9F6F0] inline-flex items-center justify-center transition-colors"
                            aria-label="Instagram"
                        >
                            <Instagram size={16} />
                        </a>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 md:px-10 mt-16 pt-8 border-t border-[#F9F6F0]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#F9F6F0]/55">
                <div>
                    © {new Date().getFullYear()} {COMPANY.name} · CVR{" "}
                    {COMPANY.cvr} · Del af {COMPANY.parent}
                </div>
                <div className="overline text-[#F9F6F0]/55">
                    Stubmarken 28 · 3230 Græsted
                </div>
            </div>
        </footer>
    );
};

export default Footer;
